// extracted by css-extract-rspack-plugin
export default {"QuestionListItem":"fkfMl","QuestionListItemIcon":"X59Li"};